import { useCallback, useRef, useState } from "react";
import OrderChangesModal from "./OrderChangesModal";

export function useOrderChangesDialog(onSaved) {
  const savedRef = useRef(onSaved);
  savedRef.current = onSaved;
  const [orderId, setOrderId] = useState(null);

  const openOrderChanges = useCallback((id) => {
    const numeric = Number(id);
    if (!Number.isFinite(numeric) || numeric <= 0) return;
    setOrderId(numeric);
  }, []);

  const changesDialog = (
    <OrderChangesModal
      orderId={orderId}
      onClose={() => setOrderId(null)}
      onSaved={async (id) => {
        setOrderId(null);
        await savedRef.current?.(id);
      }}
    />
  );

  return { changesDialog, openOrderChanges };
}
